import React, { useState } from 'react';

import Image from 'next/image';
import { useRouter } from 'next/navigation';

import Typography from '@components/Typography';
import SeturExtra from '@assets/images/setur-extra-small.png';
import { StarSmile } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';
import { useDevice } from '@contexts/device';
import { signUpGtm } from '@utils/gtm/membership-gtm';
import useGetasPath from '@hooks/useGetasPath';
import GeneralLoader from '@components/ui/GeneralLoader';

import { Card, ImageWrapper, InfoContainer } from './LoyaltyLoginBannerStyle';

const LoyaltyLoginBanner = () => {
  const asPath = useGetasPath();
  const { isDesktop } = useDevice();
  const router = useRouter();

  const [isLoading, setIsLoading] = useState(false);

  const handleLoginRedirect = () => {
    setIsLoading(true);
    signUpGtm('Ürün Detay - Hemen Üye Ol');
    router.push(`/giris-yap?redirectUrl=${encodeURIComponent(asPath)}`);
  };

  return (
    <Card>
      {isLoading && <GeneralLoader />}

      <ImageWrapper>
        <Image width={98} height={30} src={SeturExtra} alt='mobileappimage' />
      </ImageWrapper>

      <InfoContainer>
        {isDesktop ? (
          <CustomIcon icon={StarSmile} width={24} height={24} />
        ) : null}
        <Typography variant='caption2' color='D300' weight='Regular'>
          Setur Extra'nın kazandıran dünyasıyla fırsatları yakala
        </Typography>
        <Typography
          variant='caption2'
          color='D300'
          weight='SemiBold'
          as='div'
          css={{
            textDecoration: 'underline',
            color: '#000',
            cursor: 'pointer',
            fontWeight: 600,
          }}
          onClick={handleLoginRedirect}
        >
          Üye Ol ya da Giriş Yap
        </Typography>
      </InfoContainer>
    </Card>
  );
};

export default LoyaltyLoginBanner;
